import { useFormik } from "formik";
import React from "react";
import { useDispatch } from "react-redux";
import { FormFeedback, Input, Modal, ModalBody, ModalHeader } from "reactstrap";
import { postSurchargeAliseAction } from "../../../../store/Global/actions";
import * as Yup from 'yup';

const ModalAddNewAlias = ({ modal, onCloseClick }) => {
  const dispatch = useDispatch();
  const sqlSafeTextRegex = /^[a-zA-Z0-9 _-]*$/;
  const sqlInjectionPattern = /(\b(SELECT|INSERT|UPDATE|DELETE|DROP|ALTER|CREATE|EXEC|UNION|--)\b|['";\\])/i;
  const safeString = (label) =>
    Yup.string().test(
      "no-sql-injection",
      `${label} contains potentially malicious characters or SQL keywords.`,
      function (value) {
        if (!value) return true;
        return !sqlInjectionPattern.test(value);
      }
    );
  const surchargeAliasSchema = Yup.object().shape({
    name: safeString("Alias Code")
      .required()
      .max(10, 'Alias Code cannot exceed 10 characters')
      .matches(sqlSafeTextRegex, 'Special characters are not allowed'),

    description: safeString("Alias Description")
      .required()
      .max(255, 'Alias Description cannot exceed 255 characters')
      .matches(sqlSafeTextRegex, 'Special characters are not allowed'),
  });


  const surAliseFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
      description: ''
    },
    validationSchema: surchargeAliasSchema,
    onSubmit: (values) => {
      const data = {
        ...values
      }
      dispatch(postSurchargeAliseAction(data));
      surAliseFormik.resetForm();
    }
  })


  return (
    <>
      <Modal isOpen={modal} toggle={onCloseClick} className="table_view_modal">
        <ModalHeader tag="h4">
          Add Surchare Alise Code
          <span className="close" onClick={onCloseClick}></span>
        </ModalHeader>
        <ModalBody>
          <div className="table_view_data_wrap">
            <div className="charge_details">
              <div className="row mt-4 mb-2">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-4">
                  <label className="form-label">Surcharge Alias Code</label>
                  <Input
                    type="text"
                    name="name"
                    value={surAliseFormik.values.name}
                    onChange={surAliseFormik.handleChange}
                    onBlur={surAliseFormik.handleBlur}
                    id="name"
                    className="form-control"
                    placeholder="Enter Surcharge Code"
                    invalid={surAliseFormik.touched.name && surAliseFormik.errors.name ? true : false}
                  />
                  {surAliseFormik.touched.name && surAliseFormik.errors.name ? (
                    <FormFeedback> {surAliseFormik.errors.name} </FormFeedback>
                  ) : null}
                </div>

                <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-4">
                  <label className="form-label">Alias Desc</label>
                  <Input
                    type="text"
                    name="description"
                    value={surAliseFormik.values.description}
                    onChange={surAliseFormik.handleChange}
                    onBlur={surAliseFormik.handleBlur}
                    id="description"
                    className="form-control"
                    placeholder="Enter Surcharge Desc"
                    invalid={surAliseFormik.touched.description && surAliseFormik.errors.description ? true : false}
                  />
                  {surAliseFormik.touched.description && surAliseFormik.errors.description ? (
                    <FormFeedback> {surAliseFormik.errors.description} </FormFeedback>
                  ) : null}
                </div>
              </div>

              <div className="row">
                <div className="d-flex justify-content-center">
                  <div className="mb-3 mx-3 d-flex justify-content-end">
                    <button type="button" className=" btn btn-primary" onClick={surAliseFormik.handleSubmit}>Save</button>
                  </div>
                  <div className="mb-3 mx-3 d-flex justify-content-end">
                    <button type="button" className=" btn btn-primary" onClick={() => { onCloseClick(); surAliseFormik.resetForm(); }}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ModalAddNewAlias;
